import { logger } from 'modules/logger';

export class ASRPlexWebSocketService {
  static instance: ASRPlexWebSocketService | null = null;
  static connection: WebSocket | null = null;
  static currentConnectionUrl: string | null = null;

  static getInstance(): ASRPlexWebSocketService {
    if (!ASRPlexWebSocketService.instance) {
      ASRPlexWebSocketService.instance = new ASRPlexWebSocketService();
    }
    return ASRPlexWebSocketService.instance;
  }

  connect(socketUrl: string): WebSocket {
    if (
      ASRPlexWebSocketService.connection != null &&
      ASRPlexWebSocketService.currentConnectionUrl !== socketUrl
    ) {
      ASRPlexWebSocketService.connection.close();
      ASRPlexWebSocketService.connection = null;
    }

    if (ASRPlexWebSocketService.connection == null) {
      ASRPlexWebSocketService.currentConnectionUrl = socketUrl;
      const socket = new WebSocket(socketUrl);
      ASRPlexWebSocketService.connection = socket;

      ASRPlexWebSocketService.connection.onopen = () => {
        logger.info(`[ASRPlexWebSocketService] connection opened to ${socketUrl}`);
      };
      ASRPlexWebSocketService.connection.onerror = (err: any) => {
        logger.error(`[ASRPlexWebSocketService] connection error to ${socketUrl}`, err);
      };
      ASRPlexWebSocketService.connection.onclose = () => {
        logger.info('[ASRPlexWebSocketService] connection closed');
        // closure is async, so it may already have been replaced
        // by the time this event handler fires
        if (ASRPlexWebSocketService.connection === socket) {
          ASRPlexWebSocketService.connection = null;
        }
      };
    }
    return ASRPlexWebSocketService.connection;
  }
}

export const asrPlexWebSocketService: ASRPlexWebSocketService =
  ASRPlexWebSocketService.getInstance();

export class ASRPlexVADWebSocketService {
  static instance: ASRPlexVADWebSocketService | null = null;
  static connection: WebSocket | null = null;
  static currentConnectionUrl: string | null = null;

  static getInstance(): ASRPlexVADWebSocketService {
    if (!ASRPlexVADWebSocketService.instance) {
      ASRPlexVADWebSocketService.instance = new ASRPlexVADWebSocketService();
    }
    return ASRPlexVADWebSocketService.instance;
  }

  connect(socketUrl: string): WebSocket {
    if (
      ASRPlexVADWebSocketService.connection != null &&
      ASRPlexVADWebSocketService.currentConnectionUrl !== socketUrl
    ) {
      ASRPlexVADWebSocketService.connection.close();
      ASRPlexVADWebSocketService.connection = null;
    }

    if (ASRPlexVADWebSocketService.connection == null) {
      ASRPlexVADWebSocketService.currentConnectionUrl = socketUrl;
      const socket = new WebSocket(socketUrl);
      ASRPlexVADWebSocketService.connection = socket;
      ASRPlexVADWebSocketService.connection.onopen = () => {
        logger.info(`[ASRPlexVADWebSocketService] connection opened to ${socketUrl}`);
      };
      ASRPlexVADWebSocketService.connection.onerror = (err: any) => {
        logger.error(`[ASRPlexVADWebSocketService] connection error to ${socketUrl}`, err);
      };
      ASRPlexVADWebSocketService.connection.onclose = () => {
        logger.info('[ASRPlexVADWebSocketService] connection closed');
        // closure is async, so it may already have been replaced
        // by the time this event handler fires
        if (ASRPlexVADWebSocketService.connection === socket) {
          ASRPlexVADWebSocketService.connection = null;
        }
      };
    }
    return ASRPlexVADWebSocketService.connection;
  }
}

export const asrPlexVADWebSocketService: ASRPlexVADWebSocketService =
  ASRPlexVADWebSocketService.getInstance();
